exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3B9v4jo7fu6Ft8vhgWS2LM {\n  display: grid;\n  height: 100vh;\n  background: white;\n  font-size: 45px;\n  color: #075189;\n  text-align: center;\n  align-content: center;\n  justify-content: center; }\n", ""]);

// Exports
exports.locals = {
	"maintenanceContainer": "_3B9v4jo7fu6Ft8vhgWS2LM"
};